export default {
  // Floating button
  'chatbot.buttonLabel': '咨询',

  // Header
  'chatbot.headerTitle': 'GB CosPack Assistant',
  'chatbot.headerSubtitle': '咨询包材选择、报价和订单流程。',

  // Welcome message
  'chatbot.welcomeMessage': '您好。我可以帮助您了解化妆品包材选择、报价申请、AI后加工预览和订单流程。',

  // Starter questions
  'chatbot.starter.0': '如何申请报价？',
  'chatbot.starter.1': 'MOQ 是如何计算的？',
  'chatbot.starter.2': 'AI 后加工预览是什么？',
  'chatbot.starter.3': '在哪里查看订单状态？',

  // Input
  'chatbot.inputPlaceholder': '请输入消息...',
  'chatbot.send': '发送',
  'chatbot.close': '关闭',
  'chatbot.newChat': '新对话',

  // Loading
  'chatbot.loading': '正在生成回复...',

  // Error
  'chatbot.errorMessage': '暂时无法生成回复，请稍后再试。',
  'chatbot.notConfigured': '聊天机器人 API 尚未连接。请联系管理员设置后端 URL。',

  // Safety status
  'chatbot.outOfScopeNote': '请咨询包材、报价或订单相关问题。',

  // Quote CTA
  'chatbot.quoteCta': '申请报价',
  'chatbot.suggestedQuestions': '推荐问题',
};